const ADMIN_ROLES = new Set(["admin", "superuser", "super user"]);
const UNFILTERED_START_ROLES = new Set(["admin", "superuser", "super user", "supervisor"]);
const VIEW_ROLES = new Set(["admin", "superuser", "super user", "supervisor", "user", "instructor"]);

export const normalizeScheduleV2Role = (role) =>
	String(role || "")
		.trim()
		.toLowerCase();

export const readStoredAppMemberships = () => {
	try {
		const raw = localStorage.getItem("appMemberships");
		return raw ? JSON.parse(raw) : {};
	} catch (_) {
		return {};
	}
};

export const getScheduleV2Role = (memberships = readStoredAppMemberships()) => {
	const role = memberships?.scheduleV2 || memberships?.schedule_v2 || memberships?.schedule;
	return normalizeScheduleV2Role(role);
};

export const canViewScheduleV2 = (memberships) => VIEW_ROLES.has(getScheduleV2Role(memberships));

export const canManageScheduleV2 = (memberships) => ADMIN_ROLES.has(getScheduleV2Role(memberships));

export const shouldStartScheduleV2Unfiltered = (memberships) =>
	UNFILTERED_START_ROLES.has(getScheduleV2Role(memberships));
